<template>
  <div class="dialog-wrap">
    <el-dialog
      :width="width"
      :title="title"
      :show-close="showClose"
      :close-on-click-modal="closeOnModal"
      :visible.sync="visibleModel"
      :center="center"
      :modal="modal"
      :append-to-body="appendToBody"
      :custom-class="appendToBody ? 'dialog_class' : ''"
      @close="close"
      @open="open"
    >
      <div slot="title" v-if="$slots.title"><slot name="title"></slot></div>
      <div
        :class="['dialog-content', 'scroll_base', needPadding ? 'padding_class' : '']"
        :style="`height: ${contentHeight};`"
        ref="elDialogContent"
      >
        <slot name="content"></slot>
      </div>
      <div class="dialog-btns" :style="isNotBtnPadding && 'padding: 0;'" v-if="isFooter">
        <slot name="btn"></slot>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'vDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: String,
    showClose: {
      type: Boolean,
      default: false
    },
    closeOnModal: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '40%'
    },
    center: {
      type: Boolean,
      default: true
    },
    needPadding: {
      type: Boolean,
      default: true
    },
    isFooter: {
      type: Boolean,
      default: true
    },
    modal: {
      type: Boolean,
      default: true
    },
    isNotBtnPadding: {
      type: Boolean,
      default: false
    },
    contentHeight: {
      type: String,
      default: ''
    },
    appendToBody: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    visibleModel: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  methods: {
    close() {
      this.$emit('close')
      this.visibleModel = false
    },
    open() {
      this.$emit('open')
    }
  }
}
</script>

<style scoped lang="scss">
.dialog-wrap {
   /deep/ .el-dialog {
    position: absolute;
    top: 50%;
    left: 50%;
    overflow: hidden;
    margin: 0 !important;
    border-radius: 24px;
    transform: translate(-50%, -50%);

    .el-dialog__title {
      font-weight: bold;
    }
  }
   /deep/ .el-dialog__header {
    padding-bottom: 0;
    // background: #14b194;
    // // border-radius: 15px 15px 0 0;
    // .el-dialog__title {
    //   color: #fff;
    // }
    // .el-dialog__close {
    //   color: #fff;
    // }
  }
   /deep/ .el-dialog__body {
    padding: 0;
    color: #333;
  }
}
.el-dialog__header {
  padding: 24px 32px 0;
}
 /deep/ .el-dialog__close {
  color: #333;
  font-size: 24px;
  font-weight: bold;
}
.dialog-content {
  overflow-y: auto;
  max-height: 550px;
}
.padding_class {
  padding: 32px 32px 0 32px;
}
.dialog-btns {
  padding: 32px 32px 24px;
  text-align: center;
  border-radius: 0 0 16px 16px;
}

 /deep/ .el-dialog.dialog_class {
  position: absolute;
  top: 50%;
  left: 50%;
  overflow: hidden;
  margin: 0 !important;
  border-radius: 24px !important;
  transform: translate(-50%, -50%);
}

 /deep/ .dialog_class .el-dialog__title {
  font-weight: bold !important;
}
 /deep/ .dialog_class .el-dialog__body {
  padding: 0 32px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/vDialog.vue